import { DateTime } from 'luxon';

import { DateHelper } from '../helpers/DateHelper';

class ShippingData {
  constructor(params) {
    this.agency = !params.agency ? null : {
      extraCost: params.agency.extraCost,
      id: params.agency.id,
      name: params.agency.name,
    };
    this.date = DateTime.fromISO(params.date);
    this.futureDate = params.futureDate && DateTime.fromJSDate(new Date(params.futureDate));
    this.endHour = params.endHour;
    this.endHourString = DateHelper.militaryHourToString(this.endHour);
    this.price = params.price;
    this.shippingType = params.shippingType;
    this.startHour = params.startHour;
    this.startHourString = DateHelper.militaryHourToString(this.startHour);
  }
}

export { ShippingData };



// WEBPACK FOOTER //
// ./src/models/ShippingData.js